import styled from 'styled-components';

export const MethodologyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 2rem;
  padding: 0 1rem 3rem;
  font-weight: 500;

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    margin-left: 0%;
    margin-right: 0%;
  }
`;

export const MethodologyTitle = styled.h1`
  font-size: ${(props) => props.theme.fontSizeTitle};
  color: ${(props) => props.theme.titleColor};
  text-align: left;
  margin: 2rem 0 0.5rem;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMobileTitle};
  }
`;

export const MethodologySubtitle = styled.p`
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.secondaryColor};
  text-align: left;
  margin: 0 0 1.5rem;
`;

export const MethodologySection = styled.div`
  background-color: ${(props) => props.theme.secondaryColorLight};
  border-radius: ${(props) => props.theme.borderRadius};
  padding: 1.25rem;
  margin-bottom: 1.5rem;
`;

export const SectionTitle = styled.h2`
  font-size: ${(props) => props.theme.fontSizeXl};
  color: ${(props) => props.theme.titleColor};
  text-align: left;
  margin: 0 0 0.75rem;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMobileTitle};
  }
`;

export const SectionBody = styled.div`
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.secondaryColor};
  text-align: left;
  line-height: 1.6;

  p {
    margin: 0 0 0.75rem;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const SectionList = styled.ul`
  padding-left: 1.25rem;
  margin: 0.5rem 0 0;
  text-align: left;

  li {
    font-size: ${(props) => props.theme.fontSizeBase};
    color: ${(props) => props.theme.secondaryColor};
    margin: 0.4rem 0;
    line-height: 1.5;
  }
`;

export const MethodologyLabel = styled.b`
  font-weight: 700;
  color: ${(props) => props.theme.primaryColor};
`;

export const StoplightGreen = styled.b`
  font-weight: 700;
  color: ${(props) => props.theme.stoplightGreen};
  background-color: ${(props) => props.theme.secondaryColorDark};
  padding: 4px 8px;
  border-radius: 8px;
`;

export const StoplightYellow = styled.b`
  font-weight: 700;
  color: ${(props) => props.theme.stoplightYellow};
  background-color: ${(props) => props.theme.secondaryColorDark};
  padding: 4px 8px;
  border-radius: 8px;
`;

export const StoplightRed = styled.b`
  font-weight: 700;
  color: ${(props) => props.theme.stoplightRed};
  background-color: ${(props) => props.theme.secondaryColorDark};
  padding: 4px 14px;
  border-radius: 8px;
`;

export const OrderedList = styled.ol`
  padding-left: 1.25rem;
  margin: 0.5rem 0 0;
  text-align: left;

  li {
    font-size: ${(props) => props.theme.fontSizeBase};
    color: ${(props) => props.theme.secondaryColor};
    margin: 0.4rem 0;
    line-height: 1.5;
  }
`;
